import { render, staticRenderFns } from "./ActionExposureModal.vue?vue&type=template&id=2f193d9d&"
import script from "./ActionExposureModal.vue?vue&type=script&lang=js&"
export * from "./ActionExposureModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports